export const isPractice = (currentSubTask) => {
  if (currentSubTask === 'practice') {
    return true;
  }
  return false;
};
